export default __webpack_public_path__ + "static/media/rehacer.d0bf2a30.svg";